import script from "./SpecialTips.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialTips.vue?vue&type=script&setup=true&lang=js"

import "./SpecialTips.vue?vue&type=style&index=0&id=774a5ba0&lang=css"

const __exports__ = script;

export default __exports__